import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../styles/styles.css';
import '../../styles/custom-fixes.css';
import '../../styles/login.css';
import ContactUsForm from './ContactUsForm';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SeoPageLayout from '../SeoPages/SeoPageLayout';
import useSeoMeta from '../SeoPages/useSeoMeta';
import { getPublicSeoPage } from '../../seo/publicPages';

function ContactUs() {
  useSeoMeta(getPublicSeoPage('/contact-us/'));

  return (
    <SeoPageLayout activeNav="contact">
      <Container fluid className="contactus-container contactus-seo">
        <Row className="contact-layout-row">
          <Col xs={12} lg={5} className="contact-info-panel">
            <div className="contact-info-inner">
              <span className="contact-info-badge">We'd love to hear from you</span>
              <h1 className="contact-info-heading">Talk with the Complimate team</h1>
              <p className="contact-info-description">
                Need support, pricing guidance, or a tailored compliance walkthrough?
                Our specialists are ready to help you move fast and stay regulator-ready.
              </p>
              <div className="contact-info-card">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <PhoneInTalkIcon />
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Call us</span>
                    <a href="tel:1300322050" className="contact-info-link">1300 32 20 50</a>
                    <span className="contact-info-subtext">Mon – Fri, 8:30am – 6:00pm AEDT</span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <EmailOutlinedIcon />
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Email</span>
                    <a href="mailto:support@complimate.com.au" className="contact-info-link">support@complimate.com.au</a>
                    <span className="contact-info-subtext">We respond within one business day</span>
                  </div>
                </div>
              </div>
              <div className="contact-info-footnote">
                Prefer speaking with a consultant? Book a complimentary discovery call
                and we’ll tailor Complimate to your obligations.
              </div>
            </div>
          </Col>

          <Col xs={12} lg={7} className="contact-form-panel">
            <div className="contact-form-wrapper">
              <div className="contact-form-header">
                <h2>Send us a message</h2>
                <p>Share a few details and we’ll route your request to the right compliance specialist.</p>
              </div>
              <ContactUsForm
                submitLabel="Submit"
                submitButtonId="contact_page_submit"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </SeoPageLayout>
  );
}

export default ContactUs;
